import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Switch } from "@/components/ui/switch";
import { Loader2, Zap } from "lucide-react";
import { toast } from "sonner";

export default function Automations() {
  const [rules, setRules] = useState(null);
  const load = () => api.get("/automation-rules").then((r) => setRules(r.data));
  useEffect(() => { load(); }, []);

  const toggle = async (rule) => {
    await api.put(`/automation-rules/${rule.id}`, { active: !rule.active });
    toast.success(rule.active ? "Regola disattivata" : "Regola attivata");
    load();
  };

  if (!rules) return <div className="flex justify-center py-20"><Loader2 className="w-6 h-6 animate-spin text-muted-foreground" /></div>;

  return (
    <div className="space-y-4 animate-fade-up">
      <div>
        <h1 className="font-heading text-2xl md:text-3xl font-black tracking-tight">Automazioni</h1>
        <p className="text-sm text-muted-foreground">Regole di follow-up automatiche configurabili.</p>
      </div>
      <div className="rounded-lg border bg-card divide-y">
        {rules.map((r) => (
          <div key={r.id} data-testid={`rule-${r.id}`} className="flex items-center gap-4 px-4 py-4">
            <div className="w-9 h-9 rounded-md bg-amber-500/10 text-amber-500 grid place-items-center"><Zap className="w-4 h-4" /></div>
            <div className="flex-1">
              <div className="font-medium">{r.trigger}</div>
              <div className="text-sm text-muted-foreground">→ {r.action}</div>
            </div>
            <Switch checked={r.active} onCheckedChange={() => toggle(r)} data-testid={`toggle-rule-${r.id}`} />
          </div>
        ))}
      </div>
    </div>
  );
}
